import DataGrid, {
    Column,
    HeaderFilter
} from 'devextreme-react/data-grid';
import React from 'react';

import './dataGrid.scss';

interface DataGridProps {
    columns: Array<SingleColumn>,
    dataSource?: any;
    className?: string;
}

export interface CellProps<TData = any> {
    data: {
        value: any;
        displayValue: any;
        data: TData;
    }
}

type DataType = 'string' | 'number' | 'date' | 'boolean' | 'object' | 'datetime';

export interface SingleColumn {
    dataField: string;
    caption: string;
    dataType?: DataType;
    cellComponent?: React.ComponentType<CellProps>;
    hasFlag?: boolean;
    hasFilter?: boolean;
}

const dataGrid = ({ dataSource, columns, className }: DataGridProps) => {
    return (
        <DataGrid
            height={300}
            className={`dataGrid ${className ? className : ''}`}
            dataSource={dataSource}
            showColumnLines={false}
            showRowLines={false}
            showBorders={false}
            rowAlternationEnabled={false}
            hoverStateEnabled={true}
            columnAutoWidth={true}
            allowColumnResizing={true}
        >
            <HeaderFilter visible={true} />
            {columns.map(column => (
                <Column
                    key={column.dataField}
                    dataField={column.dataField}
                    caption={column.caption}
                    dataType={column.dataType}
                    cellComponent={column.cellComponent}
                    allowFiltering={column.hasFilter ?? true}
                />
            ))}
        </DataGrid>
    )
}

export default dataGrid;